import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { MixpanelService } from 'src/app/@services/mixpanel.service';

export function appRouteTrackingInitializer(): () => void {
  const router = inject(Router);
  const mixpanelService = inject(MixpanelService);
  const destroyRef = inject(DestroyRef);
  const documentRef = inject(DOCUMENT);

  return (): void => {
    router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        tap((event: NavigationEnd) => {
          mixpanelService.trackPageView(
            event.urlAfterRedirects,
            documentRef.title
          );
        }),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe();
  };
}
